// removed by extract-text-webpack-plugin
module.exports = {"wrapper-video-url__platforms":"magazines_268fr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/VideoUrl/styles.scss
// module id = 1216
// module chunks = 1